/* unplugin-vue-components disabled */import { render } from "./w-label.vue?vue&type=template&id=68f616ac&scoped=true&ts=true"
import script from "./w-label.vue?vue&type=script&lang=ts"
export * from "./w-label.vue?vue&type=script&lang=ts"

import "./w-label.vue?vue&type=style&index=0&id=68f616ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f616ac"]])

export default __exports__